/* eslint-disable */
import React from 'react'
import Icon from '@mdi/react';
import { mdiChevronDown, mdiChevronUp, mdiCheck,mdiAlert } from '@mdi/js';
import GBButton from '../../components/GBButton/GBButton';


const Panel1 = ({zoneInfo, checkPlanRequirements, billingDate}) =>{

    return (
        <div >
        <div
          style={{
            marginLeft: '20px',
            marginTop: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
          }}
        >
          <div style={{ width: '100px' }}></div>
          <div
            style={{
              width: '255px',
              height: '255px',
              minWidth: '255px',
              backgroundColor: '#F1EFEF',
              border: '1px solid #FFBE24',
              borderRadius: '10px',
            }}
          >
            <div
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
                marginLeft: '20px',
                marginTop: '20px',
                height: '20px',
              }}
            >
              $57.99 user/month
            </div>
            <div style={{ marginLeft: '20px', marginTop: '10px', fontSize: '11px', height: '30px' }}>
            $57.99 per user per month if billed monthly
            $48.07 per user per month if billed annually
            </div>
  
            <hr style={{ border: '1px solid #000000', width: '85%' }} />
  
            <div
              style={{
                fontWeight: 'bold',
                marginLeft: '20px',
                fontSize: '20px',
                height: '20px',
                marginBottom: '10px',
              }}
            >
              Advanced
            </div>
            <div style={{ marginLeft: '20px', marginRight: '20px', height: '6s0px' }}>
              Advanced building with support!
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                marginTop: '7px',
              }}
            >
              <GBButton
                Action={checkPlanRequirements}
                ActionValue="Advanced"
                text={zoneInfo.plan !== 'Advanced' ? 'Select' : 'Current Plan'}
                color={zoneInfo.plan !== 'Advanced' ? '#AE007B' : '#828282'}
                borderRadius="15px"
              />
            </div>
          </div>
          <div
            style={{
              width: '255px',
              minWidth: '255px',
              height: '255px',
              backgroundColor: '#F1EFEF',
              border: '1px solid #FFBE24',
              borderRadius: '10px',
            }}
          >
            <div
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
                marginLeft: '20px',
                marginTop: '20px',
                height: '20px',
              }}
            >
              $104.99 user/month
            </div>
            <div style={{ marginLeft: '20px', marginTop: '10px', fontSize: '11px', height: '30px' }}>
              $104.99 per user per month if billed monthly,  $88.07 per user per month if billed annually.
            </div>
            <hr style={{ border: '1px solid #000000', width: '85%' }} />
            <div
              style={{
                fontWeight: 'bold',
                marginLeft: '20px',
                fontSize: '20px',
                height: '20px',
                marginBottom: '10px',
              }}
            >
              Premium
            </div>
            <div style={{ marginLeft: '20px', marginRight: '20px', height: '35px' }}>
              Increase your limits and unleash your potential.
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                marginTop: '25px',
              }}
            >
              <GBButton
                text={zoneInfo.plan !== 'Premium' ? 'Select' : 'Current Plan'}
                Action={checkPlanRequirements}
                ActionValue="Premium"
                color={zoneInfo.plan !== 'Premium' ? '#AE007B' : '#828282'}
                borderRadius="15px"
              />
            </div>
            {zoneInfo.plan === 'Premium' ? (
              <div
                style={{
                  marginLeft: '10px',
                  marginTop: '5px',
                  marginRight: '10px',
                  fontSize: '10px',
                }}
              >
                <i>Your {zoneInfo.stripeInfo.interval} plan will auto-renew on {billingDate}</i>
              </div>
            ) : null}
          </div>
          <div
            style={{
              width: '255px',
              minWidth: '255px',
              height: '255px',
              backgroundColor: '#F1EFEF',
              border: '1px solid #FFBE24',
              borderRadius: '10px',
            }}
          >
            <div
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
                marginLeft: '20px',
                marginTop: '20px',
                height: '20px',
              }}
            >
              TBD
            </div>
            <div style={{ marginLeft: '20px', marginTop: '10px', fontSize: '11px', height: '30px' }}>
             TBD
            </div>
            <hr style={{ border: '1px solid #000000', width: '85%' }} />
            <div
              style={{
                fontWeight: 'bold',
                marginLeft: '20px',
                fontSize: '20px',
                height: '20px',
                marginBottom: '10px',
              }}
            >
              Enterprise
            </div>
            <div style={{ marginLeft: '20px', marginRight: '20px', height: '35px' }}>
              Build systems you can rely on with unprecedented speed.
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                marginTop: '25px',
              }}
            >
              <GBButton
                Action={checkPlanRequirements}
                ActionValue="Enterprise"
                text={zoneInfo.plan !== 'Enterprise' ? 'Select' : 'Current Plan'}
                color={zoneInfo.plan !== 'Enterprise' ? '#AE007B' : '#828282'}
                borderRadius="15px"
              />
            </div>
  
            {zoneInfo.plan === 'Enterprise' ? (
              <div
                style={{
                  marginLeft: '10px',
                  marginTop: '5px',
                  marginRight: '10px',
                  fontSize: '10px',
                }}
              >
                <i>Your {zoneInfo.stripeInfo.interval} plan will auto-renew on {billingDate}</i>
              </div>
            ) : null}
          </div>
  
        </div>
  
        <div
          style={{
            marginLeft: '20px',
            marginTop: '15px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
  
        </div>
  
        <div
          style={{
            marginLeft: '20px',
            marginTop: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            marginRight:'20px'
          }}
        >
          <div style={{ width: '125px', height: '20px' }}>Blocks</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            250
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            500
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            Unlimited
          </div>
        </div>
  
       
  
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
           
            border:'1px solid #F5E5C3',
            justifyContent: 'space-evenly',
            padding:'5px',
            borderRadius:'7px',
            backgroundColor:'#F1EFEF',
            marginRight:'20px'
            
          }}
        >
          <div style={{ width: '125px', height: '20px' }}>Data storage</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            100 GB
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            200 GB
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            TBD
          </div>
        </div>
  
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            borderRadius:'7px',
            marginRight:'20px'
          }}
        >
          <div style={{ width: '125px', height: '20px',whiteSpace:'nowrap' }}>Workflow actions/month</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            50,000
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
           100,000
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
           TBD
          </div>
        </div>
  
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            marginRight:'20px',
            backgroundColor:'#F1EFEF',
            border:'1px solid #F5E5C3',
          }}
        >
          <div style={{ width: '125px', height: '20px',whiteSpace:'nowrap' }}>Text Messaging Numbers*</div>
          <div style={{ display: 'flex', justifyContent: 'center', whiteSpace:'nowrap', height: '20px', width: '255px' }}>
            More in 20+ countries can be purchased
          </div>
          <div style={{ display: 'flex', whiteSpace:'nowrap', justifyContent: 'center', height: '20px', width: '255px' }}>
            More in 20+ countries can be purchased
          </div>
          <div style={{ display: 'flex', whiteSpace:'nowrap', justifyContent: 'center', height: '20px', width: '255px' }}>
            More in 20+ countries can be purchased
          </div>
        </div>
  
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            borderRadius:'7px',
            marginRight:'20px',
          }}
        >
          <div style={{ width: '125px', height: '20px', whiteSpace: 'nowrap' }}>Text Messaging**</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
           <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
        </div>
  
  
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            marginRight:'20px',
            backgroundColor:'#F1EFEF',
            border:'1px solid #F5E5C3',
          }}
        >
          <div style={{ width: '125px', height: '20px', whiteSpace: 'nowrap' }}>Email messages**</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
          <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
        </div>
  
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            borderRadius:'7px',
            marginRight:'20px',
          }}
        >
          <div style={{ width: '125px', height: '20px', whiteSpace: 'nowrap' }}>
            Records per Block
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            200,000
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            1,000,000
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
           TBD
          </div>
        </div>
  
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            marginRight:'20px',
            backgroundColor:'#F1EFEF',
            border:'1px solid #F5E5C3',
          }}
        >
          <div style={{ width: '125px', height: '20px', whiteSpace: 'nowrap' }}>Tabs per Block</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            40
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            50
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            TBD
          </div>
        </div>
  
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            borderRadius:'7px',
            marginRight:'20px',
          }}
        >
          <div style={{ width: '125px', height: '20px', whiteSpace: 'nowrap' }}>Active users</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
          Licensed
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            Licensed
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            Licensed
          </div>
        </div>
  
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            marginRight:'20px',
            backgroundColor:'#F1EFEF',
            border:'1px solid #F5E5C3',
          }}
        >
          <div style={{ width: '125px', height: '20px', whiteSpace: 'nowrap' }}>Spreadsheet view</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
        </div>
  
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            borderRadius:'7px',
            marginRight:'20px',
          }}
        >
          <div style={{ width: '125px', height: '20px', whiteSpace: 'nowrap' }}>Messaging view</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
  
        </div>
  
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            marginRight:'20px',
            backgroundColor:'#F1EFEF',
            border:'1px solid #F5E5C3',
          }}
        >
          <div style={{ width: '125px', height: '20px', whiteSpace: 'nowrap' }}>Collaboration support</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
        </div>
  
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            borderRadius:'7px',
            marginRight:'20px',
          }}
        >
          <div style={{ width: '125px', height: '20px', whiteSpace: 'nowrap' }}>Bookmarks</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
        </div>
  
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            marginRight:'20px',
            backgroundColor:'#F1EFEF',
            border:'1px solid #F5E5C3',
          }}
        >
          <div style={{ width: '125px', height: '20px', whiteSpace: 'nowrap' }}>Web Forms</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
        </div>
  
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            borderRadius:'7px',
            marginRight:'20px',
          }}
        >
          <div style={{ width: '125px', height: '20px' }}>Core field types</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
        </div>
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            marginRight:'20px',
            backgroundColor:'#F1EFEF',
            border:'1px solid #F5E5C3',
          }}
        >
          <div style={{ width: '125px', height: '20px' }}>RTF field type</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
          <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
  
        </div>
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            borderRadius:'7px',
            marginRight:'20px',
          }}
        >
          <div style={{ width: '125px', height: '20px',whiteSpace:'nowrap' }}>Masked text field type</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
          <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
          <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
        </div>
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            marginRight:'20px',
            backgroundColor:'#F1EFEF',
            border:'1px solid #F5E5C3',
          }}
        >
          <div style={{ width: '125px', height: '20px', whiteSpace: 'nowrap' }}>Private fields</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
          <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
          <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
        </div>
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            borderRadius:'7px',
            marginRight:'20px',
          }}
        >
          <div style={{ width: '125px', height: '20px', whiteSpace: 'nowrap' }}>API access</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
        </div>
        <div
           style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            marginRight:'20px',
            backgroundColor:'#F1EFEF',
            border:'1px solid #F5E5C3',
          }}
        >
          <div style={{ width: '125px', height: '20px', whiteSpace: 'nowrap' }}>History tracking on tab records</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            2 years
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
           3 years
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
           TBD
          </div>
        </div>
  
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            borderRadius:'7px',
            marginRight:'20px',
          }}
        >
          <div style={{ width: '125px', height: '20px' }}>Record sharing***</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
          <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
        </div>
  
        {/* <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px'
          }}
        >
          <div style={{ width: '125px', height: '20px', whiteSpace: 'nowrap' }}>Record sharing</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
          <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
          <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
          <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
          <Icon path={mdiCheck} size="20px" />
          </div>
        </div> */}
  
        <div
          style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            marginRight:'20px',
            backgroundColor:'#F1EFEF',
            border:'1px solid #F5E5C3',
          }}
        >
          <div style={{ width: '125px', height: '20px', whiteSpace: 'nowrap' }}>Notifications</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
          <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
          <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
          <Icon path={mdiCheck} size="20px" />
          </div>
        </div>      
  
        <div
         style={{
          marginLeft: '20px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-evenly',
          padding:'5px',
          borderRadius:'7px',
          marginRight:'20px',
        }}
        >
          <div style={{ width: '125px', height: '20px',whiteSpace:'nowrap' }}>Cross-Block relational fields</div>
          <div
            style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}
          >
             <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
        </div>
  
        <div
           style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            marginRight:'20px',
            backgroundColor:'#F1EFEF',
            border:'1px solid #F5E5C3',
          }}
        >
          <div style={{ width: '125px', height: '20px' }}>
            Custom colors 
          </div>
          <div
            style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}
          >
             <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
        </div>
  
        <div
         style={{
          marginLeft: '20px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-evenly',
          padding:'5px',
          borderRadius:'7px',
          marginRight:'20px',
        }}
        >
          <div style={{ width: '125px', height: '20px',whiteSpace:'nowrap' }}>
         Data security for tabs
          </div>
          <div
            style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}
          >
             <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
          <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
        </div>
        <div
           style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            marginRight:'20px',
            backgroundColor:'#F1EFEF',
            border:'1px solid #F5E5C3',
          }}
        >
          <div style={{ alignContent:'left',width: '125px', height: '20px',whiteSpace:'nowrap' }}>
         Nested field support
          </div>
          <div
            style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}
          >
             <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
          <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
        </div>
        <div
           style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            marginRight:'20px',
            // backgroundColor:'#F1EFEF',
            // border:'1px solid #F5E5C3',
          }}
        >
          <div style={{ alignContent:'left',width: '125px', height: '20px',whiteSpace:'nowrap' }}>
        GraceBlocks Technical support
          </div>
          <div
            style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}
          >
             <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
          <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
        </div>
        <div
           style={{
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            padding:'5px',
            marginRight:'20px',
            backgroundColor:'#F1EFEF',
            border:'1px solid #F5E5C3',
          }}
        >
          <div style={{ alignContent:'left',width: '125px', height: '20px',whiteSpace:'nowrap' }}>
         Dedicated account manager
          </div>
          <div
            style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}
          >
             {/* <Icon path={mdiCheck} size="20px" /> */}
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
          <Icon path={mdiCheck} size="20px" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', height: '20px', width: '255px' }}>
            <Icon path={mdiCheck} size="20px" />
          </div>
        </div>
  
        <div
            style={{
              display: 'flex',
              flexDirection:'column',
              // border: '1px solid #757575',
              borderRadius:'7px',
              justifyContent: 'center',
              padding:'5px',
              // height: '20px',
              // width: '100%',
              marginTop:'20px',
              marginRight: '50px',
              marginLeft: '50px',
            }}
          >
         <div> *The free plan only grants access to a single auto-procured phone number for one month if the user who creates the
          Zone validates their phone number during account creation using a US or Canadian phone number. Numbers in other countries must be purchased along with a GraceBlocks paid plan before text messaging and the $2 complementary funds can be accessed. Click here to <a href="https://www.graceblocks.com/messaging-pricing" target="_blank">learn more</a> about messaging pricing and rates across the 20+ countries GraceBlocks supports for text messaging.</div>
         <div style={{marginTop:'10px'}}>
         **GraceBlocks provides messaging funds of $2 to allow sending/receiving of initial text and email messages during this one-month period. Once depleted, to continue sending messages, more funds must be purchased in addition to upgrading to a GraceBlocks paid plan. 
          </div>
          <div style={{marginTop:'10px'}}>
          ***The free plan only has limited sharing settings. It does not offer the ability to: set the security level of the share, allow recipients to add collaboration notes, add records from the share, or set a password on the share. 
          </div>
          </div>
          
  
      </div>
    )
}

export default Panel1